import { customStyle, pxToRem } from 'styles/functions'

export const mmq = {
  body_background_color: 'white',
  html_font_reset: 82,

  card_background_color: '#f0f0f0',

  header_background_url: 'mmq/header.png',
  header_no_border: true,
  header_full_height: true,

  logo_image_url: 'mmq.svg',
  logo_height: 200,

  card_header_image_top: 'mmq/commandite_Desjardins.png',
  card_header_title_width: '243px',
  card_header_width: '355px',

  custom_image_top: customStyle(`
    width: 70%;
    margin: 0 auto ${pxToRem(40)} auto;
  `),

  token_url: 'mmq/ELap.png',
  token_width: 116,
  token_margin_left: 10,
  token_margin_right: 10,

  number_hidden: true,
  number_hidden_tokenIds: [0],

  image_icon_background_color: '#5e96b0',

  button_color: '#5e96b0',
  button_radius: 6,
  button_padding: `${pxToRem(20)}`,

  button_half_border_color: 'transparent',
  button_half_align_label_left: true,
  button_half_underline: true,
  button_half_underline_color: 'red',
  button_half_underline_width: 40,
  button_half_underline_height: 3,
  button_half_text_weight: 800,
  button_half_text_size: 19,

  text_font: `Montserrat, sans-serif`,

  title_font: `Montserrat, sans-serif`,
  title_size: 30,
  title_lineheight: 45,
  title_weight: 800,

  legend_color: '#ff4842',
  legend_size: 12,
  legend_weight: 600,
  legend_lineheight: 18,

  lock_label_weight: 800,
  lock_input_border_none: true,

  subtitle_size: 20,
  subtitle_color: '#626666',
  subtitle_weight: 700,
  subtitle_lineheight: 22,

  input_background_color: 'white',
  input_border_none: true,
  input_shadow: `${pxToRem(7)} ${pxToRem(7)} ${pxToRem(21)} #d4d4d4, -${pxToRem(7)} -${pxToRem(7)} ${pxToRem(
    21
  )} #ffffff`,
  input_checkmark_color: '#5e96b0',
  input_label_color: '#5e96b0',
  input_label_uppercase: true,
  input_error_color: '#ff4842',
  input_text_color: '#626666',
  input_text_weight: 700,

  audio_background_color: '#d6d7d8',

  footer_img_top: 'mmq/footer.png',
  footer_img_top_width: 200,
  footer_img_background_color: 'white',
  footer_background_color: '#008EA7',
  footer_text_color: 'white',
  footer_text_weight: 700,
  footer_border_hidden: true,
  footer_border_radius: 10,
}

export const mmq_parc = {
  ...mmq,
  token_url: 'mmq/Parc.png',
}

export const mmq_expo_perm = {
  ...mmq,
  token_url: 'mmq/ExpoPerm.png',
}

export const mmq_expo_temp = {
  ...mmq,
  token_url: 'mmq/ExpoTemp.png',
}
